'use client';

import type { ForwardedRef } from 'react';

import type { FlashListProps } from './FlashListProps';
import type { FlashListRef } from './FlashListRef';
import { RecyclerView } from './recyclerview/RecyclerView';

export function FlashList<T>(
  props: FlashListProps<T> & { ref?: ForwardedRef<FlashListRef<T>> },
) {
  return <RecyclerView<T> {...props} />;
}
